/**
 * Base class for external network services
 * Each external network should extend this class and implement required methods
 */
/* eslint-disable class-methods-use-this, no-unused-vars */
class ExternalNetworkService {
  constructor(networkType) {
    if (this.constructor === ExternalNetworkService) {
      throw new Error(
        'ExternalNetworkService is abstract and cannot be instantiated directly'
      );
    }
    this.networkType = networkType;
  }

  /**
   * Get the base URL for this network's API
   * Override in subclasses if different from tokkoBrokerHost
   * @returns {string} Base URL
   */
  getBaseUrl() {
    const baseUrl = localStorage.getItem('tokkoBrokerHost');

    if (!baseUrl) {
      throw new Error('Base URL is not defined');
    }

    return baseUrl;
  }

  /**
   * Get quick display data for a property
   * Must be implemented by subclasses
   * @param {string|number} id - Property identifier
   * @returns {Promise} Property data
   */
  async getQuickData(id) {
    throw new Error('getQuickData must be implemented by subclass');
  }

  /**
   * Get properties by hash/identifier list
   * Must be implemented by subclasses
   * @param {Array<string>} identifiers - List of property identifiers
   * @returns {Promise} Properties data
   */
  async getPropertiesByIdentifiers(identifiers) {
    throw new Error(
      'getPropertiesByIdentifiers must be implemented by subclass'
    );
  }

  /**
   * Get info for contact form
   * Optional - override if needed
   * @param {string|number} id - Property identifier
   * @returns {Promise} Contact info
   */
  async getInfoForContact(id) {
    throw new Error('getInfoForContact must be implemented by subclass');
  }

  /**
   * Contact real estate agent
   * Optional - override if needed
   * @param {Object} data - Contact form data
   * @returns {Promise} Response
   */
  async contactRealState(data) {
    throw new Error('contactRealState must be implemented by subclass');
  }
}
/* eslint-enable class-methods-use-this, no-unused-vars */

export default ExternalNetworkService;
